import { NavigationPlacementEnum, NavigationSidebarPlacementEnum } from "@/scripts/common/enums.js";

export function getPortfolioNavigationVisibility({ navigation, isSidebarHeroLayout, isCaseStudy }) {
    if (!navigation) {
        return {
            showAbove: false,
            showBelow: false,
            showOutside: false,
        };
    }

    if (!isSidebarHeroLayout && isCaseStudy) {
        return {
            showAbove: true,
            showBelow: false,
            showOutside: false,
        };
    }

    if (isSidebarHeroLayout) {
        return {
            showAbove: navigation?.layout?.sidebarNavPlacement === NavigationSidebarPlacementEnum.TOP,
            showBelow: navigation?.layout?.sidebarNavPlacement === NavigationSidebarPlacementEnum.BOTTOM
        };
    }

    return {
        showAbove: navigation?.layout?.position === NavigationPlacementEnum.TOP,
        showBelow: navigation?.layout?.position === NavigationPlacementEnum.BOTTOM,
        showOutside: false,
    };
}
